<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [showBack]="true"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button (click)="onAdd()" label="Add User" icon="pi pi-plus" size="small"
      [disabled]="isReadOnly()"></p-button>
    <p-button (click)="onUsersImport()" size="small" label="Import Users..." icon="pi pi-plus"
      [disabled]="isReadOnly()"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
    <div class="ml-6 flex items-center">
      <p-checkbox [(ngModel)]="showInactive" [binary]="true" (onChange)="onShowInactiveChanged()"
        name="showInactive" inputId="showInactive"></p-checkbox>
      <label for="showInactive" class="ml-2">Show Inactive Account Users</label>
    </div>
    <div class="ml-6 flex items-center">
      <label for="pugFilter" class="mr-2">Filter by Program User Group:</label>
      <p-multiSelect inputId="pugFilter" name="pugFilter" class="w-80" [options]="pugFilterOptions"
        [(ngModel)]="selectedPugFilterIds" optionLabel="name" optionValue="id" [filter]="true"
        filterBy="name" [showClear]="true" placeholder="No Filter"
        [maxSelectedLabels]="1" selectedItemsLabel="{0} groups selected"
        (onChange)="onPugFilterChanged()" (onClear)="onPugFilterChanged()"></p-multiSelect>
    </div>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid gridId="accountUsersGrid" [gridOptions]="auGridOptions"></prox-ag-grid>
  </div>
</ng-template>